import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { ProtectedRoute } from '@/router/ProtectedRoute'

export const organizationRoutes: RouteObject[] = [
  {
    path: 'organizations',
    lazy: async () => {
      const module = await import('@/features/admin/organization/layouts/OrganizationsLayout')
      return {
        element: <module.OrganizationsLayout />
      }
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const module = await import('@/features/admin/organization/pages/OrganizationListPage')
          return {
            element: <module.OrganizationListPage />
          }
        }
      },
      {
        path: 'create',
        element: (
          <ProtectedRoute
            requiredRoles={['Gerente', 'Administrador']}
            unauthorizedComponent={<Navigate to="/admin/organizations" replace />}
          />
        ),
        children: [
          {
            index: true,
            lazy: async () => {
              const module = await import(
                '@/features/admin/organization/pages/OrganizationCreatePage'
              )
              return {
                element: <module.OrganizationCreatePage />
              }
            }
          }
        ]
      },
      {
        path: ':id',
        lazy: async () => {
          const module = await import('@/features/admin/organization/pages/OrganizationPage')
          return {
            element: <module.OrganizationPage />
          }
        }
      },
      {
        path: ':id/edit',
        element: (
          <ProtectedRoute
            requiredRoles={['Gerente', 'Administrador']}
            unauthorizedComponent={<Navigate to="/admin/organizations" replace />}
          />
        ),
        children: [
          {
            index: true,
            lazy: async () => {
              const module = await import(
                '@/features/admin/organization/pages/OrganizationEditPage'
              )
              return {
                element: <module.OrganizationEditPage />
              }
            }
          }
        ]
      }
    ]
  }
]
